import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    activeMenu: '',
    activeSubmenu: '',
    standAlonePage: false,
    canvasZoom: 0,
    status: '',
    token: localStorage.getItem('token') || '',
    user : {}
  },
  getters: {
    isLoggedIn: state => !!state.token
  },
  mutations: {
    setActiveMenu: (state, activeMenu) => {
      state.activeMenu = activeMenu;
    },
    setActiveSubmenu: (state, activeSubmenu) => {
      state.activeSubmenu = activeSubmenu;
    },
    setStandAlonePage: (state, standAlonePage) => {
      state.standAlonePage = standAlonePage;
    },
    setCanvasZoom: (state, canvasZoom) => {
      state.canvasZoom = canvasZoom;
    },
    authRequest(state){
      state.status = 'loading';
    },
    authSuccess(state, token, user){
      state.status = 'success';
      state.token = token;
      state.user = user;
    },
    authError(state){
      state.status = 'error';
    },
    logout(state){
      state.status = '';
      state.token = '';
    },
  },
  actions: {
    setActiveMenu: (context, activeMenu) => {
      context.commit('setActiveMenu', activeMenu);
    },
    setActiveSubmenu: (context, activeSubmenu) => {
      context.commit('setActiveSubmenu', activeSubmenu);
    },
    setStandAlonePage: (context, standAlonePage) => {
      context.commit('setStandAlonePage', standAlonePage);
    },
    setCanvasZoom: (context, canvasZoom) => {
      context.commit('setCanvasZoom', canvasZoom);
    },
    login({commit}, user){
      return new Promise((resolve, reject) => {
        commit('authRequest');

        const qs = require('qs');
        user.grant_type = 'password';
        const userStr = qs.stringify(user);

        const url = BACKEND_LOGIN_URL + '/oauth/token';
        const username = process.env.CLIENT_USERNAME;
        const password = process.env.CLIENT_PASSWORD;
        const cltToken = Buffer.from(`${username}:${password}`, 'utf8').toString('base64');
        const headers = {
          'Authorization': 'Basic ' + cltToken,
          'Content-Type': 'application/x-www-form-urlencoded'
        };
        // console.log('URL:', url, 'data: ', userStr, 'headers: ', headers);

        axios.post(url, userStr, { headers: headers })
          .then(resp => {
            // console.log('Response: ', resp);
            const tokenVal = resp.data.access_token;
            const tokenType = resp.data.token_type[0].toUpperCase() + resp.data.token_type.slice(1);
            const token = tokenType + ' ' + tokenVal;
            const user = {};
            // console.log('token: ', token);
            localStorage.setItem('token', token);
            axios.defaults.headers.common['Authorization'] = token;
            commit('authSuccess', token, user);
            resolve(resp);
          })
          .catch(err => {
            commit('authError');
            localStorage.removeItem('token');
            reject(err.response);
          });
      });
    },
    logout({commit}) {
      return new Promise((resolve, reject) => {
        commit('logout');
        localStorage.removeItem('token');
        delete axios.defaults.headers.common['Authorization'];
        resolve();
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js